export const GET_MANAGER_COMPLAINTS = 'GET_MANAGER_COMPLAINTS';
export const GET_MANAGER_COMPLAINTS_SUCCESS = 'GET_MANAGER_COMPLAINTS_SUCCESS';
export const GET_MANAGER_COMPLAINTS_FAILED = 'GET_MANAGER_COMPLAINTS_FAILED';

export const GET_MANAGER_COMPLAINT_DETAIL = 'GET_MANAGER_COMPLAINT_DETAIL';
export const GET_MANAGER_COMPLAINT_DETAIL_SUCCESS = 'GET_MANAGER_COMPLAINT_DETAIL_SUCCESS';
export const GET_MANAGER_COMPLAINT_DETAIL_FAILED = 'GET_MANAGER_COMPLAINT_DETAIL_FAILED';

export const RESOLVE_MANAGER_COMPLAINT = 'RESOLVE_MANAGER_COMPLAINT';
export const RESOLVE_MANAGER_COMPLAINT_SUCCESS = 'RESOLVE_MANAGER_COMPLAINT_SUCCESS';
export const RESOLVE_MANAGER_COMPLAINT_FAILED = 'RESOLVE_MANAGER_COMPLAINT_FAILED';

export const REJECT_MANAGER_COMPLAINT = 'REJECT_MANAGER_COMPLAINT';
export const REJECT_MANAGER_COMPLAINT_SUCCESS = 'REJECT_MANAGER_COMPLAINT_SUCCESS';
export const REJECT_MANAGER_COMPLAINT_FAILED = 'REJECT_MANAGER_COMPLAINT_FAILED';

export const CLEAR_MANAGER_COMPLAINT_DETAIL = 'CLEAR_MANAGER_COMPLAINT_DETAIL';
